import { Box, BoxProps, Text } from '@chakra-ui/react';
import { FEATURE_FLAGS } from '~/constants/featureFlags';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';

export interface Props extends BoxProps {
  title: string;
  children: React.ReactNode;
}

export const FilterSection: React.FC<Props> = ({
  title,
  children,
  ...props
}) => {
  const ffData = useFeature(FEATURE_FLAGS.foamTalentGlobalFilters);

  return (
    <Box {...props}>
      <Text fontSize="lg" fontWeight="500" color="primary.600">
        Audience {title}
      </Text>
      {!ffData.isEnabled && (
        <Text fontSize="md" fontWeight="400" color="primary.400">
          Select one option
        </Text>
      )}
      {children}
    </Box>
  );
};
